import React from "react";
import {
  Box,
  Flex,
  Text,
  Link,
  Icon,
  SimpleGrid,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { BsLinkedin } from "react-icons/bs";

function Footer() {
  const uoRed = "#8F001A";
  const uoRedHover = "#6E0014";

  const bg = useColorModeValue("gray.50", "gray.900");
  const border = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.700", "gray.300");

  const linkStyle = {
    color: uoRed,
    textDecoration: "underline",
    textUnderlineOffset: "3px",
    fontWeight: 500,
    transition: "all 0.2s ease",
    _hover: {
      color: uoRedHover,
      textDecorationThickness: "2px",
    },
  };

  return (
    <Box bg={bg} mt={0} borderTop={`1px solid ${border}`}>
      {/* Accent line */}
      <Box h="3px" bg={uoRed} />

      <Box maxW="1200px" mx="auto" px={{ base: 6, md: 8 }} py={10}>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          
          {/* Contact Section */}
          <Box>
            <Text fontWeight="800" mb={3} fontSize="lg">
              Contact
            </Text>
            <Text color={textColor}>Dr. Burak Kantarci</Text>
            <Text color={textColor}>
              Professor & Research Chair in AI-Enabled Secure Networking
            </Text>
            <Text color={textColor}>Faculty of Engineering</Text>
            <Text color={textColor}>University of Ottawa</Text>

            <Link
              href="mailto:scvic-civic@uottawa.ca"
              display="block"
              mt={3}
              {...linkStyle}
            >
              scvic-civic@uottawa.ca
            </Link>
          </Box>

          {/* Research Group */}
          <Box>
            <Text fontWeight="800" mb={3} fontSize="lg">
              Research Group
            </Text>

            <Link
              href="https://nextconlab.ca/"
              isExternal
              display="block"
              {...linkStyle}
            >
              Next Generation Communications Lab
            </Link>

            <Link
              href="https://www.linkedin.com/company/smart-connected-vehicles-innovation-centre/about/"
              isExternal
              display="flex"
              alignItems="center"
              gap={2}
              mt={3}
              {...linkStyle}
            >
              <Icon as={BsLinkedin} />
              Smart Connected Vehicles Innovation Centre
            </Link>
          </Box>

          {/* Institutional */}
          <Box>
            <Text fontWeight="800" mb={3} fontSize="lg">
              Institution
            </Text>
            <Text color={textColor}>
              Faculty of Engineering
            </Text>
            <Text color={textColor}>
              University of Ottawa
            </Text>
            <Text color={textColor} mt={2}>
              Ottawa, Ontario, Canada
            </Text>
          </Box>
        </SimpleGrid>
      </Box>

      <Divider />

      {/* Bottom Strip */}
      <Flex
        justify="center"
        align="center"
        py={4}
        fontSize="sm"
        color="gray.500"
      >
        © {new Date().getFullYear()} University of Ottawa · All Rights Reserved
      </Flex>
    </Box>
  );
}

export default Footer;